export default __webpack_public_path__ + "static/media/step.4eab55ed.mp3";